/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { AuthUtils } from '../../../core/auth/auth.utils';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
    },
];

export const coreNavigation: FuseNavigationItem[] = [
    {
        id: 'core',
        title: 'SHORTCUTS.CORE',
        type: 'group',
        icon: 'heroicons_outline:circle-stack',
        module: AuthUtils.MODULE_CORE,
        children: [
            // {
            //     id: 'dashboard',
            //     title: 'NAVIGATION.DASHBOARD',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/core/dashboard',
            //     module: AuthUtils.MODULE_CORE,
            // },
            // {
            //     id: 'analytics',
            //     title: 'NAVIGATION.ANALYTICS',
            //     type: 'basic',
            //     icon: 'heroicons_outline:template',
            //     link: '/core/analytics'
            // },
            {
                id: 'users',
                title: 'NAVIGATION.USERS',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/core/users',
                module: AuthUtils.MODULE_USERS,
            },
            {
                id: 'roles',
                title: 'NAVIGATION.ROLES',
                type: 'basic',
                icon: 'heroicons_outline:shield-exclamation',
                link: '/core/roles',
                module: AuthUtils.MODULE_ROLES,
            },
            // {
            //     id: 'companies',
            //     title: 'NAVIGATION.COMPANIES',
            //     type: 'basic',
            //     icon: 'heroicons_outline:building-office-2',
            //     link: '/core/companies',
            // },
            {
                id: 'customers',
                title: 'NAVIGATION.CUSTOMERS',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/core/customers',
                module: AuthUtils.MODULE_CUSTOMERS,
            },
            // {
            //     id: 'partners',
            //     title: 'NAVIGATION.PARTNERS',
            //     type: 'basic',
            //     icon: 'heroicons_solid:user-group',
            //     link: '/core/partners',
            //     module: AuthUtils.MODULE_PARTNERS,
            // },
        ],
    },
    {
        id: 'system_settings',
        title: 'NAVIGATION.SYSTEM_SETTINGS_SECTION',
        type: 'group',
        module: AuthUtils.MODULE_SYSTEM_SETTINGS,
        children: [
            {
                id: 'system_settings',
                title: 'NAVIGATION.SYSTEM_SETTINGS',
                type: 'basic',
                icon: 'feather:settings',
                link: '/core/system-settings',
                module: AuthUtils.MODULE_SYSTEM_SETTINGS,
            },
        ],
    },
];

export const productManagementNavigation: FuseNavigationItem[] = [
    {
        id: 'management',
        title: 'SHORTCUTS.MANAGEMENT',
        type: 'group',
        icon: 'heroicons_outline:circle-stack',
        module: AuthUtils.MODULE_MANAGEMENT,
        children: [
            // {
            //     id: 'dashboard',
            //     title: 'NAVIGATION.DASHBOARD',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/mng/dashboard',
            //     module: AuthUtils.MODULE_MANAGEMENT,
            // },
            // {
            //     id: 'production-statuses',
            //     title: 'NAVIGATION.PRODUCTION_STATUSES',
            //     type: 'basic',
            //     icon: 'heroicons_outline:exclamation-triangle',
            //     link: '/mng/production-statuses',
            //     module: AuthUtils.MODULE_PRODUCTION_STATUSES,
            // },
            {
                id: 'vehicles',
                title: 'NAVIGATION.VEHICLES',
                type: 'basic',
                icon: 'mat_outline:directions_car',
                link: '/mng/vehicles',
                module: AuthUtils.MODULE_VEHICLES,
            },
            // {
            //     id: 'work-types',
            //     title: 'NAVIGATION.WORK_TYPES',
            //     type: 'basic',
            //     icon: 'heroicons_outline:wrench-screwdriver',
            //     link: '/mng/work-types',
            //     module: AuthUtils.MODULE_WORK_TYPES,
            // }

        ],
    },
    // {
    //     id: 'documents',
    //     title: 'NAVIGATION.DOCUMENTS',
    //     type: 'group',
    //     module: AuthUtils.MODULE_DOCUMENTS,
    //     children: [
    //         {
    //             id: 'documents',
    //             title: 'NAVIGATION.DOCUMENTS',
    //             type: 'basic',
    //             icon: 'heroicons_outline:cloud',
    //             link: '/mng/documents',
    //             module: AuthUtils.MODULE_DOCUMENTS,
    //         }
    //     ],
    // },
];

export const quoteOrderManagementNavigation: FuseNavigationItem[] = [
    {
        id: 'omng',
        title: 'SHORTCUTS.ORDERS_&_QUOTES',
        type: 'group',
        icon: 'heroicons_outline:circle-stack',
        module: AuthUtils.MODULE_QUOTE_ORDER_MANAGEMENT,
        children: [
            // {
            //     id: 'dashboard',
            //     title: 'NAVIGATION.DASHBOARD',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/omng/dashboard',
            //     module: AuthUtils.MODULE_QUOTE_ORDER_MANAGEMENT,
            // },
            // {
            //     id: 'quotes',
            //     title: 'NAVIGATION.QUOTES',
            //     type: 'basic',
            //     icon: 'heroicons_outline:queue-list',
            //     link: '/omng/quotes',
            //     module: AuthUtils.MODULE_QUOTES,
            // },
            // {
            //     type: 'divider',
            // },
            // {
            //     id: 'invoices',
            //     title: 'NAVIGATION.INVOICES',
            //     type: 'basic',
            //     icon: 'heroicons_outline:calculator',
            //     link: '/omng/invoices',
            //     module: AuthUtils.MODULE_INVOICES,
            // },
            // {
            //     id: 'payments',
            //     title: 'NAVIGATION.PAYMENTS',
            //     type: 'basic',
            //     icon: 'mat_outline:payments',
            //     link: '/omng/payments',
            //     module: AuthUtils.MODULE_PAYMENTS,
            // },
            // {
            //     type: 'divider',
            // },
            {
                id: 'projects',
                title: 'NAVIGATION.PROJECTS',
                type: 'basic',
                icon: 'heroicons_outline:puzzle-piece',
                link: '/omng/projects',
                module: AuthUtils.MODULE_PROJECTS,
            },
            {
                id: 'utilization-overview',
                title: 'NAVIGATION.UTILIZATION_OVERVIEW',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-line',
                link: '/omng/utilization-overview',
                module: AuthUtils.MODULE_PROJECTS_PLANNING_MODULE,
            },
            // {
            //     id: 'external-contractors',
            //     title: 'NAVIGATION.EXTERNAL_CONTRACTORS',
            //     type: 'basic',
            //     icon: 'feather:users',
            //     link: '/omng/external-contractors',
            //     module: AuthUtils.MODULE_EXTERNAL_CONTRACTORS,
            // },
            // {
            //     id: 'quotes',
            //     title: 'NAVIGATION.QUOTES',
            //     type: 'basic',
            //     icon: 'heroicons_outline:queue-list',
            //     link: '/omng/quotes',
            //     module: AuthUtils.MODULE_QUOTES,
            // },
            // {
            //     id: 'work-order-groups',
            //     title: 'NAVIGATION.WORK_ORDER_GROUPS',
            //     type: 'basic',
            //     icon: 'heroicons_outline:rectangle-stack',
            //     link: '/omng/work-order-groups',
            //     module: AuthUtils.MODULE_ORDERS,
            // },
            // {
            //     id: 'work-orders',
            //     title: 'NAVIGATION.WORK_ORDERS',
            //     type: 'basic',
            //     icon: 'heroicons_outline:rectangle-stack',
            //     link: '/omng/work-orders',
            //     module: AuthUtils.MODULE_WORK_ORDERS,
            // }
        ],
    },
];

export const hrLeaveManagementNavigation: FuseNavigationItem[] = [
    {
        id: 'hr',
        title: 'SHORTCUTS.HR_LEAVE_MANAGEMENT',
        type: 'group',
        icon: 'mat_outline:emoji_people',
        module: AuthUtils.MODULE_HR_LEAVE_MANAGEMENT,
        children: [
            // {
            //     id: 'dashboard',
            //     title: 'NAVIGATION.DASHBOARD',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/omng/dashboard',
            //     module: AuthUtils.MODULE_QUOTE_ORDER_MANAGEMENT,
            // },
            {
                id: 'leave_management',
                title: 'NAVIGATION.LEAVE_MANAGEMENT',
                type: 'basic',
                icon: 'mat_outline:emoji_people',
                link: '/hr/leave-management',
                module: AuthUtils.MODULE_LEAVE_MANAGEMENT,
            },
            {
                id: 'holidays_management',
                title: 'NAVIGATION.HOLIDAYS_MANAGEMENT',
                type: 'basic',
                icon: 'heroicons_outline:light-bulb',
                link: '/hr/holidays-management',
                module: AuthUtils.MODULE_HOLIDAYS_MANAGEMENT,
            }
        ],
    },
];
